import { Component, Input, OnInit } from '@angular/core';
import { BillableService } from 'src/app/core/service/billable.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import moment from 'moment';
import { GridViewManager } from 'src/app/core/model/grid-view-manager';

@Component({
  selector: 'app-patient-accumulator',
  templateUrl: './patient-accumulator.component.html',
  styleUrls: ['./patient-accumulator.component.scss']
})
export class PatientAccumulatorComponent implements OnInit
{
  public viewAccumulators: GridViewManager;
  public durationLoaded = false;
  public maxDate: Date = moment().toDate();
  public asOfDate: Date = moment().toDate();

  private currentMemberId: number;

  constructor(
    private billableService: BillableService,
    private messageHandlerService: MessageHandlerService) { }

  @Input() public set memberId(memberId: number)
  {
    if (memberId !== undefined)
    {
      this.currentMemberId = memberId;
      this.loadAccumulators();
    }
  }

  public ngOnInit(): void
  {
    this.viewAccumulators = new GridViewManager(99999);
  }

  public onAsOfDateChange(asOfDate: Date): void
  {
    if (asOfDate) 
    {
      this.loadAccumulators();
    }
  }

  private loadAccumulators(): void
  {
    this.billableService.getAccumulatorsByBillableServices(this.currentMemberId, this.asOfDate).subscribe({
      next: (accumulatorsData: any) =>
      {
        this.viewAccumulators.setData(this.billableService.getAccumulatorsData(accumulatorsData, 'accumulatorName', true));
        this.durationLoaded = this.viewAccumulators.data.filter((x: any) => x.duration).length > 0;
      },
      error: (errorMessage) =>
      {
        this.messageHandlerService.displayError(errorMessage);
      }
    });
  }
}
